import { useReducer } from 'react';
import {
    TradeInSortingField,
    type TradeInSortingRule,
    SortingOrder,
    type TradeInFilteringRule,
} from '../../../api/types';
import {
    type ExtendedPageState,
    type ExtendedPageAction,
    extendedReducer,
} from '../../../components/PaginatedTableWithContext';
import { TableSortingOrder, type SortOrderValue } from '../../../utilities/useSortAndFilterCache';

type SortRule = TradeInSortingRule & SortOrderValue;

export type TradeInListState = ExtendedPageState & {
    sort: SortRule;
    filter: TradeInFilteringRule;
};

export type SetSortAction = { type: 'setSort'; sortBy: SortRule };
export type SetFilterAction = { type: 'setFilter'; filteringRule: TradeInFilteringRule };
type Action = ExtendedPageAction | SetSortAction | SetFilterAction;

const reducer = (state: TradeInListState, action: Action): TradeInListState => {
    switch (action.type) {
        case 'setPage':
            return { ...state, page: action.page };

        case 'setPageSize':
            return { ...state, page: 0, pageSize: action.pageSize };

        case 'setSort':
            return { ...state, page: 1, sort: action.sortBy };

        case 'setFilter':
            return { ...state, page: 1, filter: action.filteringRule };

        default:
            return extendedReducer(state, action);
    }
};

export const defaultTradeInListSort = {
    field: TradeInSortingField.ApplicationDate,
    order: SortingOrder.Desc,
    orderValue: TableSortingOrder.Desc,
};

const useListReducer = (cache?: TradeInListState) =>
    useReducer(reducer, {
        companyId: cache?.companyId,
        // default pagination
        page: cache?.page || 1,
        pageSize: cache?.pageSize || 10,

        // default sorting
        sort: cache?.sort || defaultTradeInListSort,

        filter: cache?.filter || {},
    });

export default useListReducer;
